import { render, staticRenderFns } from "./Courses2.vue?vue&type=template&id=dfe92600&scoped=true&"
import script from "./Courses2.vue?vue&type=script&lang=js&"
export * from "./Courses2.vue?vue&type=script&lang=js&"
import style0 from "./Courses2.vue?vue&type=style&index=0&id=dfe92600&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe92600",
  null
  
)

export default component.exports